import { render, staticRenderFns } from "./DeliveryStatusLabel.vue?vue&type=template&id=27e8db66&"
import script from "./DeliveryStatusLabel.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports